import {
    API_SUCCESS,
    API_FAIL,
    GET_TOP_SELLING_PRODUCT,
    GET_EARNING_DATA,
    GET_REPORTED_MESSAGES,
    GET_REPORTED_MESSAGES_SUCCESS,
    GET_REPORTED_MESSAGES_FAIL,
    CHANGE_REPORTED_MESSAGE_STATUS,
    CHANGE_REPORTED_MESSAGE_STATUS_SUCCESS,
    CHANGE_REPORTED_MESSAGE_STATUS_FAIL,
} from "./actionType";

const INIT_STATE = {
    sellingData: [],
    earningData: [],
    reportedMessages: {
        data: {
            data: [],
        },
        total_pages: 1,
    },
    loading: false,
    error: null,
};

const DashboardSaas = (state = INIT_STATE, action) => {
    switch (action.type) {
        case API_SUCCESS:
            switch (action.payload.actionType) {
                case GET_TOP_SELLING_PRODUCT:
                    return {
                        ...state,
                        sellingData: action.payload.data
                    };

                case GET_EARNING_DATA:
                    return {
                        ...state,
                        earningData: action.payload.data
                    };
                default:
                    return state;
            }
        case API_FAIL:
            switch (action.payload.actionType) {
                case GET_TOP_SELLING_PRODUCT:
                    return {
                        ...state,
                        sellingDataError: action.payload.error
                    };

                case GET_EARNING_DATA:
                    return {
                        ...state,
                        earningDataError: action.payload.error
                    };

                default:
                    return state;
            }
        case GET_REPORTED_MESSAGES:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case GET_REPORTED_MESSAGES_SUCCESS:
            return {
                ...state,
                loading: false,
                reportedMessages: action.payload,
                error: null,
            };
        case GET_REPORTED_MESSAGES_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case CHANGE_REPORTED_MESSAGE_STATUS:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case CHANGE_REPORTED_MESSAGE_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
            };
        case CHANGE_REPORTED_MESSAGE_STATUS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
}

export default DashboardSaas;